export const UPDATE_CARD = 'billing/UPDATE_CARD'
export const UPDATE_CARD_STARTED = 'billing/UPDATE_CARD_STARTED'
export const UPDATE_CARD_SUCCESS = 'billing/UPDATE_CARD_SUCCESS'
export const UPDATE_CARD_FAILED = 'billing/UPDATE_CARD_FAILED'
export const CLOSE_CARD_FAILURE_MODAL = 'billing/CLOSE_CARD_FAILURE_MODAL'

export const START_TRIAL = 'billing/START_TRIAL'
export const START_TRIAL_STARTED = 'billing/START_TRIAL_STARTED'
export const START_TRIAL_SUCCESS = 'billing/START_TRIAL_SUCCESS'
export const START_TRIAL_FAILED = 'billing/START_TRIAL_FAILED'

export const UPDATE_SUBSCRIPTION_STARTED = 'billing/UPDATE_SUBSCRIPTION_STARTED'
export const UPDATE_SUBSCRIPTION_SUCCESS = 'billing/UPDATE_SUBSCRIPTION_SUCCESS'
export const UPDATE_SUBSCRIPTION_FAILED = 'billing/UPDATE_SUBSCRIPTION_FAILED'
export const UPDATE_SUBSCRIPTION = 'billing/UPDATE_SUBSCRIPTION'
export const CANCEL_SUBSCRIPTION = 'billing/CANCEL_SUBSCRIPTION'
export const CANCEL_SUBSCRIPTION_STARTED = 'billing/CANCEL_SUBSCRIPTION_STARTED'
export const CANCEL_SUBSCRIPTION_SUCCESS = 'billing/CANCEL_SUBSCRIPTION_SUCCESS'

export const FETCH_PLANS_REQUEST = 'billing/FETCH_PLANS_REQUEST'
export const FETCH_PLANS_SUCCESS = 'billing/FETCH_PLANS_SUCCESS'
export const FETCH_PLANS_FAIL = 'billing/FETCH_PLANS_FAIL'

export const FETCH_BILLING_REQUEST = 'billing/FETCH_BILLING_REQUEST'
export const FETCH_BILLING_SUCCESS = 'billing/FETCH_BILLING_SUCCESS'
export const FETCH_BILLING_FAIL = 'billing/FETCH_BILLING_FAIL'

export const FETCH_BILLING_DATA_REQUEST = 'billing/FETCH_BILLING_DATA_REQUEST'
export const FETCH_BILLING_DATA_SUCCESS = 'billing/FETCH_BILLING_DATA_SUCCESS'
export const FETCH_BILLING_DATA_FAIL = 'billing/FETCH_BILLING_DATA_FAIL'

export const APP_BILLING_EXPIRED = 'billing/APP_BILLING_EXPIRED'

export const FETCH_BILLING_INVOICES_REQUEST =
  'billing/FETCH_BILLING_INVOICES_REQUEST'
export const FETCH_BILLING_INVOICES_SUCCESS =
  'billing/FETCH_BILLING_INVOICES_SUCCESS'
export const FETCH_BILLING_INVOICES_FAIL = 'billing/FETCH_BILLING_INVOICES_FAIL'

export const FETCH_BILLING_INFORMATION_REQUEST =
  'billing/FETCH_BILLING_INFORMATION_REQUEST'
export const FETCH_BILLING_INFORMATION_SUCCESS =
  'billing/FETCH_BILLING_INFORMATION_SUCCESS'
export const FETCH_BILLING_INFORMATION_FAILED =
  'billing/FETCH_BILLING_INFORMATION_FAILED'

export const UPDATE_BILLING_INFORMATION = 'billing/UPDATE_BILLING_INFORMATION'
export const UPDATE_BILLING_INFORMATION_REQUEST =
  'billing/UPDATE_BILLING_INFORMATION_REQUEST'
export const UPDATE_BILLING_INFORMATION_SUCCESS =
  'billing/UPDATE_BILLING_INFORMATION_SUCCESS'
export const UPDATE_BILLING_INFORMATION_FAILED =
  'billing/UPDATE_BILLING_INFORMATION_FAILED'

export const GET_INVOICE_PDF_LINKS = 'billing/GET_INVOICE_PDF_LINKS'
export const GET_INVOICE_PDF_LINKS_STARTED =
  'billing/GET_INVOICE_PDF_LINKS_STARTED'
export const GET_INVOICE_PDF_LINKS_SUCCESS =
  'billing/GET_INVOICE_PDF_LINKS_SUCCESS'
export const GET_INVOICE_PDF_LINKS_FAILED =
  'billing/GET_INVOICE_PDF_LINKS_FAILED'
